import request from 'app/requests/ContractBasis/ContractBasis.requests'
import useRequest, {
    RequestKeys,
    RequestFn,
} from 'app/hooks/useRequest'
import {
    LaneGroupTemperatureRange,
    ProductType,
} from 'app/enums/label.enums'

const useGetProductTypesForTempRange = ({
    tempRange: selectedTempRange,
}: {
    tempRange?: LaneGroupTemperatureRange[],
}): {
    productTypes: ProductType[],
    isDataReady: boolean,
    error: Record<string, any>,
    isFetching: boolean,
    isError: boolean,
} => {
    const {
        data: productTypes,
        isDataReady,
        error,
        isError,
        isFetching,
    } = useRequest<ProductType[]>({
        key: RequestKeys.getProductTypesContractBasis,
        params: {
            selectedTempRange,
        },
        keepPreviousData: true,
        requestFunc: RequestFn.getEntity(request.getAllProductTypes, (promise) => {
            return promise.then((resp) => {
                return resp.data.reduce((acc, {
                    productType,
                    temperatureRange,
                }) => {
                    if (!selectedTempRange?.length
                        || selectedTempRange.includes(temperatureRange)) {
                        return [
                            ...acc,
                            productType,
                        ]
                    }

                    return acc
                }, [])
            })
        }),
    })

    return {
        productTypes,
        isDataReady,
        error,
        isFetching,
        isError,
    }
}

export default useGetProductTypesForTempRange
